<div
  class="flex items-center justify-between border-b border-(--divider-normal) bg-(--background-default) text-(--content-menubar-secondary)"
  data-testid="div-header"
>
  <div class="flex flex-1 items-stretch gap-5">
    <ng-content select="[slot=start]"></ng-content>
  </div>
  <div class="flex items-stretch divide-x divide-(--divider-panels) text-(--content-neutral-secondary)">
    <ng-content select="[slot=end]"></ng-content>
  </div>
</div>
